import React from "react";
import logo from "assets/img/henry-schein-logo-png-transparent.png";
import sidelogo from "assets/img/HS_Thrive Unlocked__Lockup.png";
import unlock from "assets/img/HS_Thrive Unlocked__K.O.png";

const NotEligible = () => {
  return (
    <>
      <style>{mobileCss}</style>

      <div style={styles.page}>
        {/* HEADER */}
        <div style={styles.fullHeader}>
          <div className="header-content" style={styles.headerContent}>
            <img
              src={logo}
              style={styles.logo}
              alt="logo"
            />

            <img
              src={sidelogo}
              style={styles.rightLogo}
              alt="side-logo"
            />
          </div>
        </div>

        {/* CARD */}
        <div style={styles.card}>
          {/* CARD HEADER */}
          <div style={styles.cardHeader}>
            <img
              src={unlock}
              style={styles.unlockLogo}
              alt="unlock"
            />
          </div>

          <div style={styles.content}>
            {/* ICON */}
            <div style={styles.errorIcon}>!</div>

            {/* TITLE */}
            <h2 style={styles.title}>We’re Sorry</h2>

            <p style={styles.subtitle}>
            We couldn’t complete your <br />
            Thrive Unlocked request online.
            </p>

            {/* ERROR BOX */}
            <div className="error-box" style={styles.errorBox}>
              <div style={styles.errorTitle}>
              This location isn’t eligible at this time.
              </div>

              <p style={styles.errorText}>
              Our records indicate your location is not eligible for Thrive Unlocked at this time.
              </p>
            </div>

            {/* DIVIDER */}
            <div style={styles.divider} />

            {/* NEXT STEP */}
            <div style={styles.section}>
              <div style={styles.sectionTitle}>Next Step</div>

              <p style={styles.sectionText}>
              Please contact your Henry Schein representative to discuss
              eligibility or available program options.
              </p>
            </div>

            {/* DIVIDER */}
            <div style={styles.divider} />

            {/* FOOTER */}
            <div style={styles.section}>
              <div style={styles.sectionTitle}>Have Questions?</div>

              <p style={styles.sectionText}>
                Contact Thrive Support—we’re here to help.
              </p>

              <div className="contact-row" style={styles.contact}>
                <span style={styles.link}>1-833-473-4968</span>

                <span className="divider-text" style={{ margin: "0 8px" }}>
                  |
                </span>

                <span style={styles.link}>
                  <a
                    href="mailto:Thrive.Support@henryschein.com"
                    style={{
                      color: "#2563eb",
                      textDecoration: "none",
                    }}
                  >
                    Thrive.Support@henryschein.com
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

/* STYLES */

const styles = {
  page: {
  background: "#eef1f5",
  minHeight: "100vh",
  margin: 0,
  padding: "16px",
  fontFamily: "Arial, sans-serif",
  overflowX: "hidden",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
},

  fullHeader: {
  width: "100%",
  maxWidth: "520px",
  background: "#fff",
  padding: "5px 16px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  margin: "0 auto 20px auto",
  boxSizing: "border-box",
  borderRadius: "10px",
},
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "15px",
  },

  logo: {
    width: "140px",
    height: "auto",
    objectFit: "contain",
  },

  rightLogo: {
    width: "220px",
    height: "auto",
    objectFit: "contain",
  },

  /* CARD */

  card: {
    width: "100%",
    maxWidth: "520px",
    margin: "0 auto",
    background: "#fff",
    borderRadius: "14px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
    overflow: "hidden",
  },

  cardHeader: {
    background: "#0A72BA",
    textAlign: "center",
    // padding: "10px",
  },

  unlockLogo: {
    width: "100%",
    maxWidth: "260px",
    objectFit: "contain",
  },

  content: {
    padding: "25px",
  },

  /* ERROR ICON */

  errorIcon: {
    width: "65px",
    height: "65px",
    borderRadius: "50%",
    border: "2px solid #ef4444",
    color: "#ef4444",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "28px",
    margin: "0 auto 15px",
    fontWeight: "bold",
  },

  /* TEXT */

  title: {
    textAlign: "center",
    color: "#0E176D",
    marginBottom: "5px",
    fontSize: "28px",
  },

  subtitle: {
    textAlign: "center",
    fontSize: "14px",
    color: "#343F88",
    marginBottom: "20px",
    lineHeight: "22px",
  },

  /* ERROR BOX */

  errorBox: {
    border: "1px solid #ef4444",
    borderRadius: "10px",
    padding: "16px",
    background: "#fff5f5",
    textAlign: "center",
  },

  errorTitle: {
    color: "#ef4444",
    fontWeight: "bold",
    marginBottom: "8px",
    fontSize: "15px",
  },

  errorText: {
    fontSize: "13px",
    color: "#343F88",
    lineHeight: "22px",
  },

  divider: {
    height: "1px",
    background: "#e5e7eb",
    margin: "20px 0",
  },

  section: {},

  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "6px",
    color: "#0E176D",
    fontSize: "16px",
  },

  sectionText: {
    fontSize: "13px",
    color: "#343F88",
    marginBottom: "10px",
    lineHeight: "22px",
  },

  contact: {
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "4px",
  },

  link: {
    color: "#2563eb",
    cursor: "pointer",
    wordBreak: "break-word",
  },
};

/* MOBILE RESPONSIVE CSS */

const mobileCss = `
*{
  box-sizing:border-box;
}

body{
  margin:0;
  padding:0;
  overflow-x:hidden;
}

@media only screen and (max-width:768px){

  .header-content{
    display:flex !important;
    flex-direction:row !important;
    justify-content:space-between !important;
    align-items:center !important;
    flex-wrap:nowrap !important;
  }

  .contact-box{
    flex-direction:column !important;
    align-items:flex-start !important;
    gap:8px !important;
  }

  .divider-line{
    display:none;
  }
}

@media only screen and (max-width:480px){

  .header-content img:first-child{
    width:100px !important;
    max-width:42% !important;
  }

  .header-content img:last-child{
    width:150px !important;
    max-width:52% !important;
  }

  h2{
    font-size:24px !important;
  }
}
`;

export default NotEligible;